import * as React from "react";
const AddIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1616_8611)">
        <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#604EA0" />
      </g>
      <defs>
        <clipPath id="clip0_1616_8611">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default AddIcon;
